module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/core/APIFactory"
// module id = 15
// module chunks = 0 1